(function () {
  var form = document.querySelector('[data-rp-form]');
  if (!form) return;

  var input = form.querySelector('input[name="codigo"]');
  var error = form.querySelector('#rp-error');

  function showError(msg) {
    if (error) {
      error.textContent = msg;
      error.removeAttribute('hidden');
    }
    input.classList.add('is-error');
    input.setAttribute('aria-invalid', 'true');
    input.focus();
  }

  function clearError() {
    if (error) error.setAttribute('hidden', '');
    input.classList.remove('is-error');
    input.removeAttribute('aria-invalid');
  }

  input.addEventListener('input', clearError);

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearError();

    var codigo = input.value.trim().replace(/\s+/g, '').toUpperCase();

    if (!codigo || codigo.length < 10) {
      showError('Digite um código de rastreamento válido');
      return;
    }

    var baseUrl = form.getAttribute('data-tracking-url') || 'https://rastreio.mandae.com.br/tracking/';
    window.open(baseUrl + codigo, '_blank', 'noopener,noreferrer');
  });
})();
